import React, { useMemo, useState } from "react";
import Chart from "react-apexcharts";

const ActivebuttonStyle={
  padding: "8px 16px",
    borderWidth: "medium",
    borderStyle: "none",
    borderColor: "#6b7280",
    borderImage: "initial",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "0.2s",
    backgroundColor: "rgb(220, 38, 38)",
    color: "#fff"
}
const buttonStyle={
  padding: "8px 16px",
    borderWidth: "medium",
    borderStyle: "none",
    borderColor: "#6b7280",
    borderImage: "initial",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "0.2s",
    backgroundColor: "transparent",
    color: "rgb(107, 114, 128)"
}

function DashboardBudgetChart({ apiData }) {
  const [currentChart,setCurrentChart] =useState("expense")

  const handleChartchange =(val)=>{
      setCurrentChart(val)
  }

  const chartData = useMemo(() => {
    const data =  currentChart === "income"
      ? apiData?.api4 || []  
      : apiData?.api2 || []; 
    return {
      categories: data.map((item) => item.month),
      expected: data.map((item) => item.foreCastAmount),
      actual: data.map((item) => item.amount),
      percentages: data.map((item) => item.usagePercentage),
    };
  }, [apiData?.api2,apiData?.api4, currentChart]);

  const budgetChartOptions = useMemo(() => ({
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
      background: "transparent",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "70%",
        borderRadius: 4,
        dataLabels: { position: "top" },
        distributed: false,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (_, opts) {
        const percentage = chartData.percentages?.[opts.dataPointIndex];
        return opts.seriesIndex === 1 &&
          percentage !== null &&
          percentage !== undefined
          ? `${percentage}%`
          : "";
      },
      style: {
        fontSize: "11px",
        fontWeight: "600",
        colors: ["#6B7280"],
      },
      offsetY: -20,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: chartData.categories,   // ✅ now always in sync
      labels: {
        style: { colors: "#6B7280", fontSize: "11px" },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        formatter: (val) =>
          val >= 1000
            ? `${(val / 1000).toFixed(0)},${String(val % 1000).padStart(3, "0")}`
            : val,
        style: { colors: "#6B7280", fontSize: "11px" },
      },
    },
    fill: { opacity: 1 },
    colors: [
      ({ seriesIndex, dataPointIndex }) => {
        if (seriesIndex === 0) return "#F8BBD9";
        const actual = chartData.actual[dataPointIndex];
        const expected = chartData.expected[dataPointIndex];
        return actual > expected ? "#6B5A85" : "#D8B4FE";  // ✅ correct color logic
      },
    ],
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      fontSize: "12px",
      markers: { width: 10, height: 10, radius: 2 },
    },
    grid: {
      borderColor: "#F3F4F6",
      strokeDashArray: 3,
    },
    tooltip: {
      y: {
        formatter: (val) => `₹${val.toLocaleString()}`,
      },
    },
  }), [chartData]);  // ✅ recomputes when chartData changes

  const budgetChartSeries = useMemo(() => [
    { name: "Budget", data: chartData.expected },
    { name: "Actual", data: chartData.actual },
  ], [chartData]);

  return (
    <div style={{ backgroundColor: "#ffffff", width: "100%", padding: "24px 90px" }}>
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          border: "1px solid #E5E7EB",
          padding: "24px",
          minHeight: "400px",
        }}
      >
        <div
          style={{
            marginBottom: "20px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1F2937", margin: "0 0 8px 0" }}>
            {currentChart === "income" ? "Income vs Forecast" : "Actual vs Budget"}
          </h2>
          <div style={{
            display: "flex",
            gap: "2px",
            marginBottom: " 24px",
            backgroundColor: "rgb(249, 250, 251)",
            padding: "4px",
            borderRadius: "12px"
          }}>
            <button style={currentChart == "expense" ? ActivebuttonStyle : buttonStyle} onClick={(e)=>handleChartchange("expense")}>
              Expense
            </button>
            <button style={currentChart == "income" ? ActivebuttonStyle : buttonStyle} onClick={(e)=>handleChartchange("income")}>
              Income
            </button>
          </div>
        </div>

        <Chart
        key={currentChart}   
          options={budgetChartOptions}
          series={budgetChartSeries}
          type="bar"
          height={320}
        />
      </div>
    </div>
  );
}

export default DashboardBudgetChart;